<modal-header title="{{label}}"></modal-header>
<ion-content>
    <ion-grid *ngIf="!!subHeader">
        <ion-row>
            <ion-col class="ion-text-end">
                {{ subHeader }}
            </ion-col>
        </ion-row>
    </ion-grid>
    <ion-item>
        <ion-input [(ngModel)]="marker"
                   inputmode="numeric"
                   class="manual-input"
                   #manualAmount>
        </ion-input>
    </ion-item>
    <ion-item>
        <ion-label position="floating">Notes</ion-label>
        <ion-textarea rows="5" [(ngModel)]="notes"></ion-textarea>
    </ion-item>
</ion-content>
<ion-footer class="ion-no-border">
    <div *ngIf="!required" class="paired-button-container">
        <ion-button color="dark"
                    class="paired-button"
                    [disabled]="(!!max && this.marker > max) || ((!!min || min === 0) && marker < min)"
                    (click)="close('NONE')">
            None
        </ion-button>
        <ion-button color="success"
                    class="paired-button"
                    (click)="submit()">
            Submit
        </ion-button>
    </div>

    <ion-button *ngIf="required" color="dark"
                class="footer-button"
                [disabled]="!marker || (!!max && this.marker > max) || ((!!min || min === 0) && marker < min)"
                (click)="submit()">
        Submit
    </ion-button>
</ion-footer>
